import { format } from 'fecha';

var getDateFormat = function getDateFormat(opts) {
  var date = opts.date,
    f = opts.format,
    _opts$seperator = opts.seperator,
    seperator = _opts$seperator === void 0 ? '/' : _opts$seperator;
  var currentDate = new Date();
  if (date && !Number.isNaN(new Date(date).getTime())) {
    currentDate = new Date(date);
  }
  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  switch (f) {
    case 'dd mm yyyy':
      return day + seperator + month + seperator + year;
    case 'mm dd yyyy':
      return month + seperator + day + seperator + year;
    case 'YYYY mm dd':
      return year + seperator + month + seperator + day;
    case 'dd mmm\'yy':
      return format(currentDate, 'DD MMM\'YY');
    default:
      return year + seperator + month + seperator + day;
  }
};
var dateToEPOC = function dateToEPOC(date) {
  var epoc = new Date(date).valueOf();
  return epoc; // unix timestamp
};

var epocToDate = function epocToDate(epoc) {
  var d = getDateFormat({
    date: epoc
  });
  return d;
};
var getYearsAgoDateFromNow = function getYearsAgoDateFromNow(age) {
  if (age === void 0) {
    age = 0;
  }
  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var month = currentDate.getMonth() + 1 < 10 ? "0" + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1;
  var day = currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate();
  return new Date(year + "/" + month + "/" + day);
};
var getYearsAgoDate = function getYearsAgoDate(age, month, day) {
  if (age === void 0) {
    age = 0;
  }
  if (month === void 0) {
    month = 0;
  }
  if (day === void 0) {
    day = 1;
  }
  var currentDate = new Date();
  var year = currentDate.getFullYear() - age;
  var newMonth = month + 1 < 10 ? "0" + (month + 1) : month + 1;
  var newDay = day < 10 ? "0" + day : day;
  return new Date(year + "/" + newMonth + "/" + newDay);
};
var isDateExpired = function isDateExpired(_ref) {
  var now = _ref.now,
    expire = _ref.expire;
  return now > expire;
};
var formatDate = function formatDate(date, formatStr) {
  if (formatStr === void 0) {
    formatStr = "D MMM'YY dddd";
  }
  return format(date, formatStr);
};
var formatDateString = function formatDateString(date) {
  return date && formatDate(date).split(' ').slice(0, 2).join(' ');
};
var formatDayString = function formatDayString(date) {
  return date && formatDate(date).split(' ').slice(2).join('');
};
var addDays = function addDays(date, days) {
  var currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate;
};
var daysInMonth = function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
};
var getTimeZone = function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export { addDays, dateToEPOC, daysInMonth, epocToDate, formatDate, formatDateString, formatDayString, getDateFormat, getTimeZone, getYearsAgoDate, getYearsAgoDateFromNow, isDateExpired };
